import { FloatingFormItem } from '@/components/_common';
import CfopSelectField from '@/components/_common/CfopSelectField';
import { useUpdateInvoiceItemCfop } from '@/core/domain/invoice/invoiceItem/invoiceItem.hook';
import { useRouteMatchParam } from '@/hooks';
import { Col, Form, Modal, Row } from 'antd';

interface Props {
  open: boolean;
  onCancel: () => void;
}

const NoteItemsSelectCfopModal = ({ open, onCancel }: Props) => {
  const [form] = Form.useForm();

  const { mutateAsync } = useUpdateInvoiceItemCfop();

  const invoiceId = useRouteMatchParam('invoiceId');

  return (
    <Modal
      title="Selecionar CFOP"
      open={open}
      onCancel={onCancel}
      onOk={() => {
        mutateAsync({
          invoiceId: Number(invoiceId),
          cfopId: form.getFieldValue('cfop'),
        });
        onCancel();
      }}
    >
      <Form form={form}>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <FloatingFormItem name="cfop" label="CFOP">
              <CfopSelectField />
            </FloatingFormItem>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default NoteItemsSelectCfopModal;
